import {useEffect, useState} from "react";
import { Button } from "../../../../../../components/ui/Button";
import {participationDetailsGetAPI, participationDetailsSaveAPI} from "../../../../../../services/api/project";
import { Colors } from "../../../../../../components/theme";
import { useTranslation } from "react-i18next";
import { TxtTitles } from "../../../../../../helpers/breadCrumbs";
import { Link } from "react-router-dom";
import DarkCard from "../../../../../../components/card/DarkCard";
import ParticipationEventItem from "./ParticipationEventItem";
import Select from "react-select";
import select_styles from "../../../../../../layouts/elements";


const ParticipationDetailForm = ({detailFormProps, dispatch}) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
  const [selectInstr, setSelectInstr] = useState({value: 0, label: detailFormProps.instrument});

  useEffect(() => {
    const get_data = async () => {
      const response =  await participationDetailsGetAPI(detailFormProps.projectID, detailFormProps.musicianID, detailFormProps.instrument);
      if (response.status === 200) {
        setFormData(response.data);
      }
    };
    get_data();
  }, [detailFormProps]);

  const saveFormular = async () => {
    const data = {
      projectID: detailFormProps.projectID,
      events: formData.events.map((entry) => ({
        id: Number(entry.id),
        what_marked: entry.what_marked || '',
        comment: entry.comment || ''
      })),
      musicianID: detailFormProps.musicianID,
      instrument: detailFormProps.instrument,
      confirmation: formData.confirmation,
      change_instrument: selectInstr.label,
    };

    await participationDetailsSaveAPI(data);

    dispatch({type: "SET_SHOW_TABLE", showTable: true})
  };

  const handleChangeAll = (status) => {
    const formData_copy = structuredClone(formData)
    formData_copy.events.forEach(eventItem => {
      eventItem.what_marked = status
    })
    setFormData(formData_copy)
  }

  const handleChangeAttendance = (evID, status) => {
    const formData_copy = structuredClone(formData)
    const find_entry = formData_copy.events.find(el => el.id === evID)
    if (find_entry) {
      find_entry.what_marked = status
    }
    setFormData(formData_copy)
  }

  const handleCommentChange = (ev, value) => {
    const formData_copy = structuredClone(formData)
    const find_entry = formData_copy.events.find(el => el.id === ev)
    if (find_entry) {
      find_entry.comment = value
    }
    setFormData(formData_copy)
  }

  const handleChangeConfirm = (status) => {
    const formData_copy = structuredClone(formData)
    formData_copy.confirmation = status
    setFormData(formData_copy)
  }

  const changeInstrHandler = (val) => {
    setSelectInstr(val)
  }

  return (
    <>
      <DarkCard classNames="mb-3 row">
        <TxtTitles>{t("project.project_name_title")}</TxtTitles>
        <h1 className="mb-0 mt-0 p-0" style={{ marginTop: "-5px" }}>
          {formData.projectName}
        </h1>

        <div className="mt-3">
          <p className="mb-1">{t('project.availabilities.table_mus_title')}: <b>{detailFormProps.username}</b></p>
          <p>{t('project.availabilities.table_instr_title')}: <b>{detailFormProps.instrument}</b></p>
        </div>

        <div className="row">
          {formData.events && formData.events.length > 0 ? (
            formData.events.map((event, index) => (
              <ParticipationEventItem
                key={index}
                event={event}
                handleChangeAttendance={handleChangeAttendance}
                onCommentChange={handleCommentChange}
              />
            ))
          ) : (
            <div>
              <p style={{color:'#d62429'}}>{t('project.availabilities.no_dates_specified')}</p>
              <p><b><Link to={'/projects/current/' + detailFormProps.projectID}> &#10151; {t('common.button.go_to_project')} </Link></b></p>
            </div>
          )}
        </div>

        {formData.events && formData.events.length > 0 && (
          <div className="mt-4 mb-4 d-flex gap-2">
            <button
              type="button"
              className="btn btn-success btn-sm"
              onClick={() => handleChangeAll('1')}
            >
              ✓ {t('common.button.accept_all')}
            </button>

            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => handleChangeAll('')}
            >
              {t('common.button.reset')}
            </button>

            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={() => handleChangeAll('X')}
            >
              ✖ {t('common.button.decline_all')}
            </button>
          </div>
        )}
      </DarkCard>

      {formData.events && formData.events.length > 0 && (
        <DarkCard classNames="mb-3 row">
          <TxtTitles>
          {t("project.availabilities.kzm_approval_title")}
          </TxtTitles>

          {t("project.availabilities.final_decision_description")}

          <div className="ps-0 mt-2 mb-2">
            <input
              className="me-2"
              type="radio"
              name="projectFinalDecision"
              id="decision_none"
              value="none"
              // checked={finalDecision === 'none'}
              checked={formData.confirmation === 'none'}
              onChange={(e) => handleChangeConfirm(e.target.value)}
            />
            <label className="" htmlFor="decision_none">
              {t("project.availabilities.kzm_no_descision")}
            </label>
          </div>

          <div className="ps-0 mb-2">
            <input
              className="me-2"
              type="radio"
              name="projectFinalDecision"
              id="decision_decline"
              value="decline"
              checked={formData.confirmation === 'decline'}
              onChange={(e) => handleChangeConfirm(e.target.value)}
            />
            <label className="form-check-label" htmlFor="decision_decline">
              {t("project.availabilities.kzm_decline")}
            </label>
          </div>

          <div className="ps-0 mb-2">
            <input
              className="me-2"
              type="radio"
              name="projectFinalDecision"
              id="decision_accept"
              value="accept"
              checked={formData.confirmation === 'accept'}
              onChange={(e) => handleChangeConfirm(e.target.value)}
            />
            <label className="form-check-label" htmlFor="decision_accept">
              {t("project.availabilities.kzm_approval")}
            </label>
          </div>
        </DarkCard>
      )}

      {formData.instruments_options && formData.instruments_options.length > 1 &&
          <DarkCard classNames="mb-3 row">
            <h2>Pokazujemy sekcje tą tylko gdy muzyk ma więcej niż jeden instrument !!</h2>
            <TxtTitles>
              {t("project.availabilities.mus_instrument")}
            </TxtTitles>

            {t("project.availabilities.mus_instr_desc")}

            <div className="ps-0 mt-2 mb-2">
              <Select
                  options={formData.instruments_options}
                  styles={select_styles}
                  unstyled
                  value={selectInstr}
                  onChange={val => changeInstrHandler(val)}
              />
            </div>
          </DarkCard>
      }

      <DarkCard classNames="mb-3 row">
        <Button
          className='me-4'
          variant='round'
          style={{backgroundColor: `${Colors.green}`}}
          name='save'
          onClick={saveFormular}
          type="submit">
          {t("common.button.save")}
        </Button>

        <Button
          type='submit'
          variant="round"
          onClick={() => {dispatch({type: "SET_SHOW_TABLE", showTable: true})}}
          styling="bordered"
          className={'me-3'}>
          {t("common.button.cancel")}
        </Button>
      </DarkCard>
    </>
  );
};

export default ParticipationDetailForm;